import React, {memo} from 'react'
import cx from 'classnames'
import {find} from 'lodash'

/* Components */
import HbImageView from '../../../../../components/HbImage/view/HbImageView'
import HbPlaceholderFrame from '../../../../../components/Placeholder/frame/HbPlaceholderFrame'

/* Utils */
import {formatPrice} from '../../../../../modules/product/productDesktopUtils'

/* Constants */
import {
  DESKTOP_VARIANT_SHAPE_IMAGE_PROPS as VARIANT_SHAPE_IMAGE_PROPS,
  DESKTOP_VARIANT_TYPE_PROPS as VARIANT_TYPE_PROPS,
} from '../../../../../modules/variant/variantConstants'

/* Styles */
import s from './variant-box.scss'

const VariantBox = ({
  className,
  variant,
  activeVariant,
  onClickVariant,
  imageContainerClassName,
  unAvailableVariants,
  isShowPrice,
  variantType,
  variantShape,
  isAvailableProduct,
  isInStock,
  variantName,
  isFashionProduct
}) => {

  const isUnAvailableVariant = find(unAvailableVariants, {
    ...activeVariant?.values,
    [variant.name]: variant?.value,
  })

  const handleOnClickVariant = () => {
    if (onClickVariant) {
      onClickVariant(variant)
    }
  }

  const handleMouseOver = (data) => {
    let selectItem = document.getElementById('preview-image');
    if(process.env.BROWSER && isFashionProduct && selectItem) {
      let replaceImage = data?.thumbnail?.notFormattedUrl?.replace?.('{size}', '424-600') || '';
      selectItem.style.backgroundImage = `url(${replaceImage})`;
    }
  }

  const handleMouseOut = () => {
    let selectItem = document.getElementById('preview-image');
    if(process.env.BROWSER && isFashionProduct && selectItem) {
      selectItem.style.backgroundImage = '';
    }
  }

  const isActive = activeVariant?.values?.[variant?.name] === variant?.value
  const isDisabled = Boolean(isUnAvailableVariant) || (isActive && !isAvailableProduct) || !isInStock

  return (
    <button
      className={cx(
        s.root,
        {[s.withImage]: isFashionProduct && VARIANT_TYPE_PROPS[variantType]?.isShowImage},
        {[s.withPrice]: isShowPrice},
        {[s.active]: isActive},
        {[s.disabled]: isDisabled},
        s[variantShape],
        className,
      )}
      data-test-id={`variant-box-${variant?.name}-${variant?.value}`}
      aria-label={`${isActive ? 'Seçili':''} ${variant?.name} ${variant?.value}`}
      onClick={handleOnClickVariant}
      onMouseOver={isFashionProduct && variantName === 'Renk' ? () => handleMouseOver(variant) : null}
      onMouseOut={isFashionProduct && variantName === 'Renk' ? () => handleMouseOut() : null}>
      {
        VARIANT_TYPE_PROPS[variantType]?.isShowImage &&
        <div className={cx(s.imageContainer, s[variantShape], imageContainerClassName)}>
          {
            variant?.thumbnail &&
            <HbPlaceholderFrame
              ratio={VARIANT_SHAPE_IMAGE_PROPS[variantType][variantShape].width / VARIANT_SHAPE_IMAGE_PROPS[variantType][variantShape].height}>
              <HbImageView
                image={{
                  alt: `${isActive ? 'Seçili':''} ${variant?.name} ${variant?.value}`,
                  src: variant?.thumbnail?.url,
                  size: `${VARIANT_SHAPE_IMAGE_PROPS[variantType][variantShape].width}-${VARIANT_SHAPE_IMAGE_PROPS[variantType][variantShape].height}`,
                  componentSize: {
                    width: VARIANT_SHAPE_IMAGE_PROPS[variantType][variantShape].width,
                    height: VARIANT_SHAPE_IMAGE_PROPS[variantType][variantShape].height,
                  },
                }}/>
            </HbPlaceholderFrame>
          }
        </div>
      }
      <div className={s.variantInfo}>
        {
          variantName !== 'Renk' &&
          <span className={s.name} data-test-id={'variant-box-name'}>
            {variant?.value}
          </span>
        }
        {
          isShowPrice && Boolean(variant?.price) && (
            <span className={s.price} data-test-id={'variant-box-price'}>
              {variant.isInStock ? formatPrice(variant?.price) : null}
            </span>
          )
        }
      </div>
    </button>
  )
}

export default memo(VariantBox)
